


















import Vue from "vue";
import { sortTypes } from "@/config";

export default Vue.extend({
  props: ['sortType'],
  data: () => ({
    sortTypes: sortTypes
  })
});
